export const PISTE_AUTH_API_ENDPOINT_DEV =
  'https://sandbox-oauth.piste.gouv.fr/api/oauth/token';
export const PISTE_AUTH_API_ENDPOINT_PROD =
  'https://oauth.piste.gouv.fr/api/oauth/token';

export const PISTE_API_ROOT_DEV = 'https://sandbox-api.piste.gouv.fr/';
export const PISTE_API_ROOT_PROD = 'https://api.piste.gouv.fr/';

export const OFFICIAL_JOURNAL_GET_ORDINANCE_API_ENDPOINT =
  'dila/legifrance/lf-engine-app/consult/getJoWithNor';
